import React, { useEffect, useState } from "react";

import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "styled-components";
import { isAfter } from "date-fns";

import StoreWhite from "../../../../../img/store-white.svg";
import HighPriory from "../../../../../img/priority_high.svg";
import SearchIcon from "../../../../../img/search-icon.svg";
import DoneWhite from "../../../../../img/done_white.svg";
import LinkBlack from "../../../../../img/link_black.svg";
import send_filled_white from "../../../../../img/send_filled_white.svg";
import WhatsWhite from "../../../../../img/whatsapp_white.svg";
import SmsWhite from "../../../../../img/sms_white.svg";
import EmailWhite from "../../../../../img/email_white.svg";

import VerifiedWhite from "../../../../../img/verified-white.svg";
//import DoneWhite from '../../../../img/done_white.svg';
//import api from '../../../../services/api';
import { Invoice, LinkPagamento, LinkFatura } from "../../../../../model/model";

import momentTZ from "moment-timezone";
import api from "../../../../../services/api";
import CopyToClipboard from "react-copy-to-clipboard";
import axios from "axios";
import ModalInfo from "./modalInfo";
//import debounce from 'lodash.debounce';

interface ModalProps {
  modalVisible: boolean;
  setModalVisible(b: boolean): void;
  getTransacoes(): void;
  selectedLink?: LinkPagamento;
}

const DECIMAL_NUMBER = 10;

export default function LinkModal(props: ModalProps) {
  const { modalVisible, setModalVisible, getTransacoes } = props;

  const [showScroll, setShowScroll] = useState(false);

  const [faturaInput, setFaturaInput] = useState("");
  const [faturaSearch, setFaturaSearch] = useState("");

  const [selectedInvoices, setSelectectedInvoices] = useState<number[]>([]);

  const [clienteVinculado, setClienteVinculado] = useState(true);
  const [clienteCheck, setClientCheck] = useState(false);
  const [faturaVinculada, setFaturaVinculada] = useState(false);

  const [clienteInput, setClientInput] = useState("");
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [UClist, setUClist] = useState<any[]>([]);
  const [invoicesMandatory, setInvoicesMandatory] = useState<Invoice[]>();

  const [uc, setUc] = useState("-");
  const [doc, setDoc] = useState("");
  const [cliente, setCliente] = useState("");

  //const [selectedInvoices, setSelectectedInvoices] = useState<number[]>([]);
  const [loadingInvoices, setLoadInvoices] = useState(false);

  const [faturasVinculadas, setFaturasVinculadas] = useState<Invoice[]>([]);

  const [addFaturas, setAddFaturas] = useState(false);
  const [osCorte, setOsCorte] = useState(false);

  const [docSearchedFail, setDocSearchedFail] = useState(false);

  function calcValorTotal() {
    let value = 0;

    faturasVinculadas.forEach((fv) => {
      const t = Number(fv.C1_TOTAL_CORRIGIDO);
      value = t + value;
    });

    return renderMoney(value);
  }

  useEffect(() => {
    if (invoices) {
      const f = invoices.find((i) => i.OS_CORTE === "S");
      if (f) {
        setOsCorte(true);
      }
    }
    const mandInv = invoices.filter((ti: Invoice) => checkIfMandatory(ti));

    setInvoicesMandatory(mandInv);
  }, [invoices]);

  const statuses = [
    "Processando",
    "Em andamento",
    "Cancelado",
    "Falha",
    "Pendente",
    "Processado",
    "",
    "Conflito",
    "Chargeback",
  ];

  function removerFaturaVinculada(f_id: number) {
    const faturasVinc = [...faturasVinculadas];
    const indexVinc = faturasVinc.findIndex((fv) => fv.FATURA_ID === f_id);
    if (indexVinc !== -1) {
      faturasVinc.splice(indexVinc, 1);
    }

    // setInvoiceList(f_id);
    setFaturasVinculadas([...faturasVinc]);
    setCreatedLink(undefined);
  }
  /*function removerFaturaVinculada(f_id: number) {
		const faturasVinc = [...faturasVinculadas];
		const indexVinc = faturasVinc.findIndex((fv) => fv.FATURA_ID === f_id);
		if (indexVinc !== -1) {
			faturasVinc.splice(indexVinc, 1);
		}

		// setInvoiceList(f_id);
		setFaturasVinculadas([...faturasVinc]);
	}*/

  /*function setarFaturaVinculada() {
		const filter = invoices.filter((inv) =>
			selectedInvoices.includes(inv.FATURA_ID)
		);
		if (filter && filter.length > 0) {
			setFaturasVinculadas([...filter, ...faturasVinculadas]);
			setSelectectedInvoices([]);
		} else {
			setFaturasVinculadas([]);
		}
	} */

  /*function getStatusColor() {
    const data = [
      { label: "", color: "", value: -1 },
      { label: "Processando", color: "#1588D1", value: 0 },
      { label: "Em andamento", color: "#1588D1", value: 1 },
      { label: "Cancelado", color: "#757575", value: 2 },
      { label: "Falha", color: "#E53935", value: 3 },
      { label: "Pendente", color: "#7CB342", value: 4 },
      { label: "Completo", color: "#7CB342", value: 5 },
      { label: "Em conflito", color: "#FFBB33", value: 7 },
      { label: "CHARGEBACK", color: "#5E35B1", value: 8 },
      { label: "Rejeitado", color: "#757575", value: 9 },
      { label: "Restrito", color: "#757575", value: 11 },
      { label: "Registrado", color: "#7CB342", value: 12 },
    ];

    const f = data.find((d) => d.value === link?.status);
    if (f) {
      return f.color;
    }
    return "#676767";
  }*/

  const tipos = ["", "Débito", "Crédito"];

  function renderMoney(value: any) {
    value = parseFloat(value);
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      style: "currency",
      currency: "BRL",
    });
  }

  function handleScroll() {
    if (showScroll === false) {
      setShowScroll(true);

      setTimeout(() => {
        setShowScroll(false);
      }, 2000);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(modalVisible);
    if (!modalVisible) {
      setClienteVinculado(false);
      setFaturaVinculada(false);

      setClientCheck(false);
      setFaturaVinculada(false);
      setClientInput("");
      setFaturaInput("");
      setInvoices([]);
      setUc("-");
      setDoc("");
      setCliente("");
      setFaturaSearch("");
      setInvoices([]);
      setSelectectedInvoices([]);
      setFaturasVinculadas([]);
    } else {
      setClienteVinculado(false);
      setFaturaVinculada(false);
    }
  }, [modalVisible]);

  function formatDoc() {
    let value = doc;
    value = value.replace(/\D/g, "");
    if (value.length <= 11) {
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    } else {
      value = value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        "$1.$2.$3/$4-$5"
      );
    }
    return value;
  }
  /*
	function setInvoiceList(f_id: number) {
		const si = [...selectedInvoices];

		const index = si.findIndex((si) => si === f_id);

		if (index !== -1) {
			console.log(f_id);

			si.splice(index, 1);
		} else {
			si.push(f_id);
		}

		setSelectectedInvoices([...si]);
	}
	*/

  //GET /admin/ws/ref?doc=43861172291
  //GET /admin/ws/ref/15865/invoices

  /*
	function VinculadasValorRestanteStyled() {
		const res = VinculadasValorRestante();
		if (res > 0) {
			return `+ ${renderMoney(res.toString())}`;
		} else if (res === 0) {
			return `${renderMoney(res.toString())}`;
		} else {
			return `- ${renderMoney(Math.abs(res).toString())}`;
		}
	}
*/

  function setInvoiceList(f_id: number) {
    const si = [...selectedInvoices];

    const index = si.findIndex((si) => si === f_id);

    if (index !== -1) {
      console.log(f_id);

      si.splice(index, 1);
    } else {
      si.push(f_id);
    }

    setSelectectedInvoices([...si]);
  }

  // checa mandatorio
  function checkIfMandatory(inv: Invoice): boolean {
    if (
      inv.FORMA_PAGAMENTO === "O" &&
      getSituation(inv) !== 4 &&
      getSituation(inv) !== 5 &&
      inv.FLAG_CLIENTE_ATUAL === "1" &&
      !getProc(inv) &&
      ["ABER", "REAV", "TRAN"].includes(inv.SIT_FATURA_EDT)
    ) {
      return true;
    }

    return false;
  }

  function checkIdList(invoiceIdparse: number | null): boolean {
    if (invoiceIdparse) {
      const resp = selectedInvoices?.filter((invoice) => {
        return invoice === invoiceIdparse;
      });
      if (resp)
        if (resp?.length > 0) {
          return true;
        }
    }
    return false;
  }

  // Seta os juros, multas e correções da fatura selcionada
  function handlePaymentButton(invoice: Invoice): void {
    if (!checkIfMandatory(invoice)) {
      const resp = selectedInvoices?.filter((inv) => {
        return inv !== invoice.FATURA_ID;
      });
      if (resp) {
        if (resp?.length === selectedInvoices?.length) {
          if (invoice.FATURA_ID)
            setSelectectedInvoices([...selectedInvoices, invoice.FATURA_ID]);
        } else {
          setSelectectedInvoices(resp);
        }
      } else {
        if (invoice.FATURA_ID) setSelectectedInvoices([invoice.FATURA_ID]);
      }
    } else {
      const index = invoicesMandatory?.findIndex(
        (i) => i.FATURA_ID === invoice.FATURA_ID
      );
      if (invoicesMandatory)
        if (index !== undefined)
          if (index !== -1) {
            if (index === invoicesMandatory.length - 1) {
              if (checkIdList(invoice.FATURA_ID)) {
                const resp = selectedInvoices?.filter((inv) => {
                  return inv !== invoice.FATURA_ID;
                });

                if (resp) {
                  if (resp?.length === selectedInvoices?.length) {
                    if (invoice.FATURA_ID)
                      setSelectectedInvoices([
                        ...selectedInvoices,
                        invoice.FATURA_ID,
                      ]);
                  } else {
                    setSelectectedInvoices(resp);
                  }
                } else {
                  if (invoice.FATURA_ID)
                    setSelectectedInvoices([invoice.FATURA_ID]);
                }
              } else if (index !== 0) {
                // console.log(checkIdList(invoicesMandatory[index + 1].FATURA_ID),invoicesMandatory[index+1].FATURA_ID,invoicesMandatory)

                if (checkIdList(invoicesMandatory[index - 1].FATURA_ID)) {
                  const resp = selectedInvoices?.filter((inv) => {
                    return inv !== invoice.FATURA_ID;
                  });
                  if (resp) {
                    if (resp?.length === selectedInvoices?.length) {
                      if (invoice.FATURA_ID)
                        setSelectectedInvoices([
                          ...selectedInvoices,
                          invoice.FATURA_ID,
                        ]);
                    } else {
                      setSelectectedInvoices(resp);
                    }
                  } else {
                    if (invoice.FATURA_ID)
                      setSelectectedInvoices([invoice.FATURA_ID]);
                  }
                } else {
                  // handlePriorityModalOld(true);
                }
              } else if (invoicesMandatory.length === 1 && index === 0) {
                const resp = selectedInvoices?.filter((inv) => {
                  return inv !== invoice.FATURA_ID;
                });
                if (resp) {
                  if (resp?.length === selectedInvoices?.length) {
                    if (invoice.FATURA_ID)
                      setSelectectedInvoices([
                        ...selectedInvoices,
                        invoice.FATURA_ID,
                      ]);
                  } else {
                    setSelectectedInvoices(resp);
                  }
                } else {
                  if (invoice.FATURA_ID)
                    setSelectectedInvoices([invoice.FATURA_ID]);
                }
              }
            } else if (checkIdList(invoice.FATURA_ID)) {
              if (!checkIdList(invoicesMandatory[index + 1].FATURA_ID)) {
                const resp = selectedInvoices?.filter((inv) => {
                  return inv !== invoice.FATURA_ID;
                });
                if (resp) {
                  if (resp?.length === selectedInvoices?.length) {
                    if (invoice.FATURA_ID)
                      setSelectectedInvoices([
                        ...selectedInvoices,
                        invoice.FATURA_ID,
                      ]);
                  } else {
                    setSelectectedInvoices(resp);
                  }
                } else {
                  if (invoice.FATURA_ID)
                    setSelectectedInvoices([invoice.FATURA_ID]);
                }
              } else {
                // handlePriorityModalOld(false);
              }
            } else if (index !== 0) {
              if (checkIdList(invoicesMandatory[index - 1].FATURA_ID)) {
                const resp = selectedInvoices?.filter((inv) => {
                  return inv !== invoice.FATURA_ID;
                });
                if (resp) {
                  if (resp?.length === selectedInvoices?.length) {
                    if (invoice.FATURA_ID)
                      setSelectectedInvoices([
                        ...selectedInvoices,
                        invoice.FATURA_ID,
                      ]);
                  } else {
                    setSelectectedInvoices(resp);
                  }
                } else {
                  if (invoice.FATURA_ID)
                    setSelectectedInvoices([invoice.FATURA_ID]);
                }
              } else {
                // handlePriorityModalOld(true);
              }
            } else {
              const resp = selectedInvoices?.filter((inv) => {
                return inv !== invoice.FATURA_ID;
              });
              if (resp) {
                if (resp?.length === selectedInvoices?.length) {
                  if (invoice.FATURA_ID)
                    setSelectectedInvoices([
                      ...selectedInvoices,
                      invoice.FATURA_ID,
                    ]);
                } else {
                  setSelectectedInvoices(resp);
                }
              } else {
                if (invoice.FATURA_ID)
                  setSelectectedInvoices([invoice.FATURA_ID]);
              }
            }
          }
    }
  }

  function setarFaturaVinculada() {
    const filter = invoices.filter((inv) =>
      selectedInvoices.includes(inv.FATURA_ID)
    );
    if (filter && filter.length > 0) {
      setFaturasVinculadas([...filter, ...faturasVinculadas]);
      setSelectectedInvoices([]);
    } else {
      setFaturasVinculadas([]);
    }
    setFaturaSearch("");
    setFaturaInput("");
    setAddFaturas(false);
  }

  function searchUcDoc(s: string, docSearched?: boolean) {
    if (s.length >= 11) {
      getDoc(s);
    } else getInvoices(s, docSearched);

    /*if (s.length >= 11) {
			getDoc(s);
		} else {
		}*/
  }

  async function getDoc(doc: string) {
    setLoadInvoices(true);

    try {
      const response = await api.get(`/admin/ws/ref?doc=${doc}`);
      //console.log(response.data);
      if (response.data) {
        setDoc(doc);
        if (
          response.data.length === 1 &&
          response.data[0] &&
          response.data[0].IDENT_UC
        ) {
          searchUcDoc(response.data[0].IDENT_UC);
          setUc(response.data[0].IDENT_UC);
        } else {
          setUClist(response.data);
          setLoadInvoices(false);
        }

        setUClist(response.data);
        setLoadInvoices(false);
      } else {
        setLoadInvoices(false);
      }
    } catch (error) {
      console.log(error);
      setLoadInvoices(false);
    }
  }
  async function getInvoices(uc: string, docSearched?: boolean) {
    setLoadInvoices(true);
    try {
      const response = await api.get(`/admin/ws/ref/${uc}/invoices?limit=60`);
      // console.log(response.data);
      if (response.data && response.data.length > 0) {
        setUc(uc);
        if (response.data && response.data[0]) {
          setDoc(
            response.data[0].NUMERO_DOCTO_1
              ? response.data[0].NUMERO_DOCTO_1
              : ""
          );
          setCliente(
            response.data[0].NOME_CLIENTE ? response.data[0].NOME_CLIENTE : ""
          );
          setFaturasVinculadas([]);
        }
        setInvoices(response.data.reverse());

        setClienteVinculado(true);
        setClientCheck(true);
        setUClist([]);
        setDocSearchedFail(false);
      } else {
        setInvoices([]);
        if (docSearched) {
          setDocSearchedFail(true);
        }
      }
      setLoadInvoices(false);
    } catch (error) {
      console.log(error);
      setLoadInvoices(false);
    }
  }

  const [createdLink, setCreatedLink] = useState<LinkPagamento | undefined>();
  const [loadingCreateLink, setLoadingCreateLink] = useState(false);
  async function createPaymentLink() {
    setLoadingCreateLink(true);
    try {
      const f = [] as any[];
      faturasVinculadas.forEach((fv) => {
        f.push({
          id: fv.FATURA_ID,
        });
      });
      const postData = {
        doc,
        uc,
        cliente,
        faturas: f,
      };
      const response = await api.post(`admin/link`, postData);
      if (response.data) {
        if (response.data.id) {
          // const responsePatch =
          await api.patch(`admin/link/${response.data.id}/status`, {
            status: 1,
          });
        }
        setCreatedLink(response.data);
        setOpenModalInfo(true);

        getTransacoes();
      }
      setLoadingCreateLink(false);
    } catch (error) {
      console.log(error);
      setLoadingCreateLink(false);
    }
  }

  async function sendEmailSmsWhats(type: string, content: any) {
    try {
      const uname = process.env.REACT_APP_UNAME || "";
      const pass = process.env.REACT_APP_PASS || "";
      const url =
        type === "mail"
          ? "https://bot-rpa.metasix.solutions/api/v1/mail-sms-whats"
          : type === "whatsapp"
          ? " https://api-chatbot.amazonasenergia.com/api/stone/whatsapp"
          : "https://api-chatbot.amazonasenergia.com/api/stone/sms";
      const postData = type === "mail" ? { type, content } : content;
      
      const token2 = `${process.env.REACT_APP_SMSWHATS_TOKEN}`
      const response = await axios.post(
        url,
        postData,
        type === "mail"
          ? {
              auth: {
                username: uname,
                password: pass,
              },
            }
          : {
            
              headers: {
                Authorization: `Bearer ${token2}`,
              },
            }
      );

      if (response.data) {
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
    return false;
  }

  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [modalInfoType, setModalInfoType] = useState<string | undefined>();

  // Seta a situação das Faturas
  function getSituation(situation: Invoice): number {
    /*if (
      situation.NUM_LOTE_ARREC !== null &&
      ['TRAN', 'ABER', 'REAV'].includes(situation.SIT_FATURA_EDT)
    ) {
      return 5
    }*/
    if (
      situation.CAUC_061_DT_FIM_VIGENCIA !== null &&
      ["TRAN", "ABER", "REAV"].includes(situation.SIT_FATURA_EDT)
    ) {
      if (situation.CAUC_061_DT_FIM_VIGENCIA.length < 10) {
        const dateConf = `${situation.CAUC_061_DT_FIM_VIGENCIA.substr(
          0,
          6
        )}20${situation.CAUC_061_DT_FIM_VIGENCIA.substr(6, 8)}`;
        if (checkDueDate(dateConf)) {
          return 6;
        }
      } else if (situation.CAUC_061_DT_FIM_VIGENCIA.length === 10) {
        if (checkDueDate(situation.CAUC_061_DT_FIM_VIGENCIA)) {
          return 6;
        }
      }
    }

    const situationsInvoices = [
      { id: 1, name: "TRAN", type: 2 },
      { id: 2, name: "ABER", type: 2 },
      { id: 3, name: "REAV", type: 2 },
      { id: 4, name: "PAGR", type: 4 },
      { id: 5, name: "PAGA", type: 4 },
      { id: 6, name: "PROC", type: 5 },
      { id: 7, name: "CONF", type: 5 },
    ];
    const respoSituation = situationsInvoices.filter(
      (sit) => sit.name === situation.SIT_FATURA_EDT
    )[0].type;
    if (respoSituation) {
      return respoSituation;
    }
    return 0;
  }

  function checkDueDate(dataInvoice: string): boolean {
    const [day, month, year] = dataInvoice.split("/");
    const dateInvoice = new Date(
      parseInt(year, DECIMAL_NUMBER),
      parseInt(month, DECIMAL_NUMBER) - 1,
      parseInt(day, DECIMAL_NUMBER)
    );
    const newDate = new Date();
    dateInvoice.setHours(23, 59, 59, 999);

    return isAfter(dateInvoice, newDate);
  }
  // checka se invoice esta em analise
  function getAnalise(invoiceItem: Invoice): boolean {
    return invoiceItem.FORMA_PAGAMENTO === "I";
  }

  // checka se invoice esta processando
  function getProc(invoiceItem: Invoice): boolean {
    return (
      invoiceItem.SIT_FATURA_EDT === "PROC" ||
      invoiceItem.SIT_FATURA_EDT === "CONF"
    );
  }

  return (
    <Modal
      fullscreen
      dialogClassName="hide-this-modal"
      centered={false}
      animation={false}
      show={modalVisible}
      onHide={() => {
        setModalVisible(false);
      }}
    >
      {openModalInfo && createdLink && (
        <ModalInfo
          modalVisible={openModalInfo}
          setModalVisible={setOpenModalInfo}
          // type={modalInfoType}
          sendEmailSmsWhats={sendEmailSmsWhats}
          createdLink={createdLink}
        />
      )}
      <Modal.Body>
        <div
          onClick={(e) => {
            e.preventDefault();
            setModalVisible(false);
          }}
          style={{
            position: "fixed",
            height: "100vh",
            width: "100vw",
            //background: 'rgba(0,0,0,0.1)',
            top: 0,
            left: 0,
            display: "flex",
            //flexDirection:'row',
            justifyContent: "flex-end",
          }}
        >
          <ModalMainContainer
            visible={showModal}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <ModalHeader>
              <HeaderTitle>{"Link de Pagamento"}</HeaderTitle>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <HeaderButton
                  onClick={(e) => {
                    e.preventDefault();
                    //EditEmpresa();
                    setModalVisible(false);
                  }}
                  style={{ background: "transparent", color: "#676767" }}
                >
                  Cancelar
                </HeaderButton>
              </div>
            </ModalHeader>
            <ModalContainer showScroll={showScroll}>
              <BodyMenu>
                {clienteVinculado ? (
                  <MenuItem showChecked={clienteCheck}>
                    <p className="menu_item_title menu_margin_b-8">Cliente</p>

                    <div className="menu_margin_b-16">
                      <p className="menu_item_label menu_margin_b-2">nome</p>
                      <p className="menu_item_info">{cliente}</p>
                    </div>

                    <div
                      className={clienteCheck ? "menu_margin_b-16" : ""}
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ marginRight: 25 }}>
                        <p className="menu_item_label menu_margin_b-2">UC</p>
                        <p className="menu_item_info">{uc}</p>
                      </div>
                      <div>
                        <p className="menu_item_label menu_margin_b-8=2">
                          documento
                        </p>
                        <p className="menu_item_info">{formatDoc()}</p>
                      </div>
                    </div>

                    {/* clienteCheck && (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          searchUcDoc(clienteInput);
                        }}
                        className="menu_input_container"
                      >
                        {clienteInput.length === 0 && (
                          <img
                            style={{ width: 12, height: 12 }}
                            alt="search"
                            src={SearchIcon}
                          />
                        )}
                        <input
                          type="text"
                          value={clienteInput}
                          onChange={(e) => {
                            setClientInput(e.target.value);
                          }}
                          placeholder="Buscar por UC ou documento"
                        />
                        {clienteInput.length > 0 && (
                          <button
                            type="submit"
                            onClick={(e) => {
                              e.preventDefault();
                              searchUcDoc(clienteInput);
                            }}
                            className="menu_search_button"
                          >
                            Buscar
                          </button>
                        )}
                      </form>
                    )*/}

                    <OverlayTrigger
                      key={"1"}
                      placement="left"
                      //className='warning_fixed'
                      overlay={
                        <Tooltip id="menu_tool_tip">
                          <span style={{ textTransform: "capitalize" }}>
                            Cliente vinculado
                          </span>
                        </Tooltip>
                      }
                    >
                      <div className="menu_top_fixed_tr_checked">
                        <img alt="v" src={VerifiedWhite} />
                      </div>
                    </OverlayTrigger>
                  </MenuItem>
                ) : UClist.length > 0 ? (
                  <MenuItem showWarning={true}>
                    <p className="menu_item_title menu_margin_b-32">
                      {loadingInvoices
                        ? `Buscando UC: ${uc}`
                        : docSearchedFail
                        ? `Não foram encontradas faturas para a UC ${uc}`
                        : `Selecionar UC para ${doc}`}
                    </p>
                    {UClist.map((ucl) => {
                      return (
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!loadingInvoices) {
                              setUc(ucl.IDENT_UC);
                              searchUcDoc(ucl.IDENT_UC,true);
                            }
                          }}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            marginTop: "12px",
                            border: "1px solid #1069d9",
                            borderRadius: "16px",
                            //backgroundColor: "#a9bed8",
                            padding: "12px",
                            backgroundColor:'rgb(12 80 165)'
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <p
                              style={{
                                font: "normal normal 700 16px/20px Roboto",
                                color: "#ffffff",
                                //color: "#222222",
                              }}
                            >
                              Unidade Consumidora:
                            </p>
                            <p
                              style={{
                                font: "normal normal 500 16px/20px Roboto",
                                color: "#ffffff",
                                //color: "#ff4646",
                              }}
                            >
                              {ucl.IDENT_UC}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                              marginTop: "8px",
                            }}
                          >
                            <p
                              style={{
                                font: "normal normal 700 16px/18px Roboto",
                                color: "#ffffff",
                                //color: "#222222",
                              }}
                            >
                              Endereço da UC:
                            </p>
                            <p
                              style={{
                                font: "normal normal 500 16px/18px Roboto",
                                color: "#ffffff",
                                //color: "#222222",
                              }}
                            >
                              {`${ucl.LOGR_TIPO_NOME} - ${ucl.NOME_BAIRRO}`}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                    <OverlayTrigger
                      key={"1"}
                      placement="left"
                      //className='warning_fixed'
                      overlay={
                        <Tooltip id="menu_tool_tip">
                          <span style={{ textTransform: "capitalize" }}>
                            nenhum cliente vinculado
                          </span>
                        </Tooltip>
                      }
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                        className="menu_top_fixed_tr"
                      >
                        <img alt="!" src={HighPriory} />
                      </div>
                    </OverlayTrigger>
                  </MenuItem>
                ) : (
                  <MenuItem showWarning={true}>
                    <p className="menu_item_title menu_margin_b-32">
                      Vincular cliente
                    </p>

                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        searchUcDoc(clienteInput);
                      }}
                      className="menu_input_container"
                    >
                      {clienteInput.length === 0 && (
                        <img
                          style={{ width: 12, height: 12 }}
                          alt="search"
                          src={SearchIcon}
                        />
                      )}
                      <input
                        type="text"
                        value={clienteInput}
                        onChange={(e) => {
                          setClientInput(e.target.value);
                        }}
                        placeholder="Buscar por UC ou documento"
                      />
                      {clienteInput.length > 0 && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            searchUcDoc(clienteInput);
                          }}
                          className="menu_search_button"
                        >
                          {loadingInvoices ? "Buscando" : `Buscar`}
                        </button>
                      )}
                    </form>

                    <OverlayTrigger
                      key={"1"}
                      placement="left"
                      //className='warning_fixed'
                      overlay={
                        <Tooltip id="menu_tool_tip">
                          <span style={{ textTransform: "capitalize" }}>
                            nenhum cliente vinculado
                          </span>
                        </Tooltip>
                      }
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                        className="menu_top_fixed_tr"
                      >
                        <img alt="!" src={HighPriory} />
                      </div>
                    </OverlayTrigger>
                  </MenuItem>
                )}
                {
                  <MenuItem
                    showWarning={!(faturasVinculadas.length > 0)}
                    showChecked={faturasVinculadas.length > 0}
                  >
                    <p className="menu_item_title menu_margin_b-8">
                      {faturasVinculadas.length > 0 && !addFaturas
                        ? "Faturas selecionadas"
                        : "Selecionar faturas"}
                    </p>

                    {faturasVinculadas.length > 0 && !addFaturas && (
                      <table style={{ marginTop: "12px" }}>
                        <thead>
                          <tr className="">
                            <th className="menu_item_label menu_padding_b-16">
                              Fatura
                            </th>
                            <th className="menu_item_label menu_padding_b-16">
                              Vencimento
                            </th>
                            <th className="menu_item_label float_right menu_padding_b-16">
                              Valor
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {faturasVinculadas.map((inv) => {
                            return (
                              <tr key={`${inv.FATURA_ID}`} className="">
                                <td className="menu_item_info_bold menu_padding_b-16 h-32px">
                                  {inv.DT_REF_EDT}{" "}
                                  {parseInt(inv.FD) > 0 ? " - " + inv.FD : ""}
                                </td>
                                <td className="menu_item_info_regular menu_padding_b-16 h-32px">
                                  {inv.DT_VENCIMENTO_EDT}
                                </td>
                                <td
                                  style={{
                                    background: "transparent",
                                    boxShadow: "none",
                                  }}
                                  className="menu_item_info_bold menu_item_info_value_container float_right menu_margin_b-16"
                                >
                                  <div className="text_container">
                                    {renderMoney(inv.C1_TOTAL_CORRIGIDO)}
                                  </div>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      removerFaturaVinculada(inv.FATURA_ID);
                                    }}
                                    type="button"
                                    className="delete_button"
                                  >
                                    -
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}

                    {clienteVinculado &&
                    (faturasVinculadas.length === 0 || addFaturas) ? (
                      <FaturaScroll>
                        <div className="tableContainer">
                          <table>
                            <thead>
                              <tr className="">
                                <th className="menu_item_label menu_padding_b-16">
                                  Fatura
                                </th>
                                <th className="menu_item_label menu_padding_b-16">
                                  Vencimento
                                </th>
                                <th
                                  style={{ width: "120px" }}
                                  className="menu_item_label menu_padding_b-16"
                                >
                                  Obrigatoriedade
                                </th>
                                <th
                                  style={{ textAlign: "right" }}
                                  className="menu_item_label menu_padding_b-16"
                                >
                                  Valor
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {invoices.map((inv) => {
                                if (
                                  inv.DT_REF_EDT.includes(faturaSearch) &&
                                  !faturasVinculadas.find(
                                    (fv) => fv.FATURA_ID === inv.FATURA_ID
                                  ) &&
                                  getSituation(inv) !== 4 &&
                                  !getAnalise(inv) &&
                                  !getProc(inv)
                                )
                                  return (
                                    <tr className="" key={inv.FATURA_ID}>
                                      <td
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handlePaymentButton(inv);
                                          // setInvoiceList(inv.FATURA_ID);
                                        }}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <div
                                          className="select_button"
                                          style={{
                                            background:
                                              selectedInvoices.includes(
                                                inv.FATURA_ID
                                              )
                                                ? "#28A745"
                                                : "#FFFFFF",
                                          }}
                                        >
                                          <img alt="v" src={DoneWhite} />
                                        </div>
                                        {inv.DT_REF_EDT}{" "}
                                        {parseInt(inv.FD) > 0
                                          ? " - " + inv.FD
                                          : ""}
                                        {/*invoicesMandatory?.find(
                                          (invm) =>
                                            invm.FATURA_ID === inv.FATURA_ID
                                        )
                                          ? "--mandatory--"
                                        : ""*/}
                                      </td>
                                      <td>{inv.DT_VENCIMENTO_EDT}</td>
                                      <td>
                                        {invoicesMandatory?.find(
                                          (invm) =>
                                            invm.FATURA_ID === inv.FATURA_ID
                                        ) ? (
                                          <span
                                            style={{
                                              padding: "8px",
                                              paddingTop: "4px",
                                              paddingBottom: "4px",
                                              background: "#E8F5EC",
                                              borderRadius: "40px",
                                              color: "#009353",
                                            }}
                                          >
                                            {" "}
                                            Obrigatorio
                                          </span>
                                        ) : (
                                          <span
                                            style={{
                                              padding: "8px",
                                              paddingTop: "4px",
                                              paddingBottom: "4px",
                                              background: "#f5e8e8",
                                              borderRadius: "40px",
                                              color: "#930000",
                                            }}
                                          >
                                            {" "}
                                            Facultativo
                                          </span>
                                        )}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {renderMoney(inv.C1_TOTAL_CORRIGIDO)}
                                      </td>
                                    </tr>
                                  );
                                return null;
                              })}
                            </tbody>
                          </table>
                        </div>
                        <button
                          disabled={selectedInvoices.length === 0}
                          style={{
                            backgroundColor:
                              selectedInvoices.length === 0
                                ? "#f0f0f0"
                                : "#28a745",
                            color:
                              selectedInvoices.length === 0
                                ? "#9f9f9f"
                                : "#ffffff",
                          }}
                          type="button"
                          className="botaoVincular"
                          onClick={(e) => {
                            e.preventDefault();
                            setarFaturaVinculada();
                          }}
                        >
                          Vincular fatura selecionada
                        </button>
                      </FaturaScroll>
                    ) : null}

                    {clienteVinculado && (
                      <form
                        style={{ display: "none" }}
                        onSubmit={(e) => {
                          e.preventDefault();

                          setFaturaSearch(faturaInput);
                        }}
                        className="menu_input_container"
                      >
                        <input
                          type="text"
                          value={faturaInput}
                          onChange={(e) => {
                            setFaturaInput(e.target.value);
                          }}
                          placeholder="Buscar por fatura ou ano"
                        />
                        {faturaInput.length > 0 && (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setFaturaSearch(faturaInput);
                            }}
                            className="menu_search_button"
                          >
                            Buscar
                          </button>
                        )}
                      </form>
                    )}

                    {faturasVinculadas.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <p
                          style={{
                            font: "normal normal 700 13px/18px Roboto",
                            color: "#222222",
                          }}
                        >
                          Total:
                        </p>
                        <p
                          style={{
                            font: "normal normal 700 13px/18px Roboto",
                            color: "#222222",
                          }}
                        >
                          {calcValorTotal()}
                        </p>
                      </div>
                    )}
                    {faturasVinculadas.length > 0 && !addFaturas && (
                      <button
                        style={{ marginTop: "16px" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (!loadingCreateLink) createPaymentLink();
                        }}
                        className="green_round_button"
                      >
                        {loadingCreateLink
                          ? "Criando link de pagamento"
                          : "Criar link de pagamento"}
                      </button>
                    )}

                    {faturasVinculadas.length > 0 && (
                      <button
                        style={{ marginTop: "16px", display: "none" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setAddFaturas(!addFaturas);
                          // if (!loadingCreateLink) createPaymentLink();
                        }}
                        className="green_round_button"
                      >
                        {addFaturas ? "Voltar" : "Adicionar faturas"}
                      </button>
                    )}

                    <OverlayTrigger
                      key={"1"}
                      placement="left"
                      //className='warning_fixed'
                      overlay={
                        <Tooltip id="menu_tool_tip">
                          <span style={{ textTransform: "capitalize" }}>
                            Cliente encontrado
                          </span>
                        </Tooltip>
                      }
                    >
                      <div className="menu_top_fixed_tr_checked">
                        <img alt="v" src={VerifiedWhite} />
                      </div>
                    </OverlayTrigger>
                  </MenuItem>
                }

                {createdLink && (
                  <MenuItem>
                    <p className="menu_item_title menu_margin_b-8">
                      Enviar Link de Pagamento
                    </p>
                    <div
                      style={{
                        marginTop: "16px", // display: "none"
                      }}
                      className="menu_input_container"
                    >
                      <img
                        style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "14px",
                        }}
                        alt="link"
                        src={LinkBlack}
                      />
                      <ElipisisText
                        style={{
                          maxWidth: "395px",
                        }}
                      >{`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${createdLink.id}?secret=${createdLink.secret}`}</ElipisisText>
                      <CopyToClipboard
                        text={`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${createdLink.id}?secret=${createdLink.secret}`}
                      >
                        <CopyButton
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setOpenModalInfo(true);
                          }}
                          style={{ width: "150px", marginLeft: "24px" }}
                        >
                          <img alt="copy" src={send_filled_white} />
                          <span>Enviar link</span>
                        </CopyButton>
                      </CopyToClipboard>
                    </div>
                    <div
                      style={{
                        // display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gridGap: "16px",
                        marginTop: "16px",
                        display: "none",
                      }}
                    >
                      <CopyButton
                        onClick={(e) => {
                          setOpenModalInfo(true);
                          setModalInfoType("whatsapp");
                        }}
                        style={{ width: "100%" }}
                      >
                        <img alt="Whats" src={WhatsWhite} />
                        <span>Enviar por WhatsApp</span>
                      </CopyButton>
                      <CopyButton
                        onClick={(e) => {
                          setOpenModalInfo(true);
                          setModalInfoType("sms");
                        }}
                        style={{ width: "100%" }}
                      >
                        <img alt="sms" src={SmsWhite} />
                        <span>Enviar por SMS</span>
                      </CopyButton>
                      <CopyButton
                        onClick={(e) => {
                          setOpenModalInfo(true);
                          setModalInfoType("mail");
                        }}
                        style={{ width: "100%" }}
                      >
                        <img alt="e-mail" src={EmailWhite} />
                        <span>Enviar por E-mail</span>
                      </CopyButton>
                    </div>
                  </MenuItem>
                )}

                {/* <MenuItem>
                  <div
                    className="menu_margin_b-20"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p className="menu_item_title">Pagamento </p>
                    <div
                      style={{
                        background: getStatusColor(),
                      }}
                      className="menu_item_status"
                    >
                      {statuses[transacao?.status]}
                    </div>
                  </div>
                  <div
                    className="menu_margin_b-16"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p className="menu_item_label">total pago</p>
                    <p className="menu_item_heavy">
                      {renderMoney(transacao?.valor)}
                    </p>
                  </div>

                  <div
                    className="menu_margin_b-16"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p className="menu_item_label">Criado em</p>
                    <p className="menu_item_info">
                      {momentTZ
                        .tz(transacao?.cadastro, "America/Sao_Paulo")
                        .format("DD/MM/YYYY HH:mm:ss")}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p className="menu_item_label">Processado em</p>
                    <p className="menu_item_info">
                      {transacao?.processado
                        ? momentTZ
                            .tz(transacao?.processado, "America/Sao_Paulo")
                            .format("DD/MM/YYYY HH:mm:ss")
                        : "-"}
                    </p>
                  </div>
                </MenuItem>*/}

                {/* <MenuItem>
                  <p className="menu_item_title menu_margin_b-8">
                    Ponto de Venda
                  </p>

                  <div
                    className="menu_margin_b-16"
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <p className="menu_item_label menu_margin_b-2">
                        nome da loja
                      </p>
                      <p className="menu_item_info">
                        {transacao?.pontoVenda &&
                        transacao?.pontoVenda.unidade &&
                        transacao?.pontoVenda.unidade.nome
                          ? transacao.pontoVenda.unidade.nome
                          : "-"}
                      </p>
                    </div>
                    <div>
                      <p className="menu_item_label menu_margin_b-2">
                        Identificador
                      </p>
                      <p className="menu_item_info">
                        {transacao?.pontoVenda
                          ? transacao?.pontoVenda.apelido.toUpperCase()
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="menu_item_label menu_margin_b-2">Cidade</p>
                    <p className="menu_item_info">
                      {transacao?.pontoVenda &&
                      transacao?.pontoVenda.unidade &&
                      transacao?.pontoVenda.unidade.cidade
                        ? transacao?.pontoVenda.unidade.cidade
                        : "-"}
                    </p>
                  </div>

                  <OverlayTrigger
                    key={"1"}
                    placement="left"
                    overlay={
                      <Tooltip id="menu_tool_tip">
                        <span style={{ textTransform: "capitalize" }}>
                          item local
                        </span>
                      </Tooltip>
                    }
                  >
                    <div className="menu_bottom_fixed_br">
                      <img alt="store" src={StoreWhite} />
                    </div>
                  </OverlayTrigger>
                </MenuItem>*/}

                {/* <MenuItem style={{ display: "none" }}>
                  <p className="menu_item_title menu_margin_b-8">Ajuri</p>

                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginRight: 25 }}>
                      <p className="menu_item_label menu_margin_b-2">
                        Identificador
                      </p>
                      <p className="menu_item_info">
                        {`transacao?.identificador || '-'`}
                      </p>
                    </div>
                    <div>
                      <p className="menu_item_label menu_margin_b-8=2">cupom</p>
                      <p className="menu_item_info">
                        {`transacao?.cupom || '-'`}
                      </p>
                    </div>
                  </div>
                </MenuItem>*/}

                {<div style={{ background: "transparent", padding: 10 }} />}
              </BodyMenu>
              {/*<BodyMenu style={{ marginLeft: 16 }}>
                <MenuItem>
                  <p className="menu_item_title menu_margin_b-8">
                    Detalhes da transação
                  </p>

                  <div className={""}>
                    <div
                      className="menu_margin_b-16"
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <p className="menu_item_label menu_margin_b-2">Tipo</p>
                        <p className="menu_item_info">
                          {tipos[parseInt(transacao.tipo)]} (
                          {transacao.parcelas ? transacao.parcelas : "1"}x)
                        </p>
                      </div>
                      <div>
                        <p className="menu_item_label menu_margin_b-8=2">
                          Valor
                        </p>
                        <p className="menu_item_info">
                          {renderMoney(transacao.valor)}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <p className="menu_item_label menu_margin_b-2">Pan</p>
                        <p className="menu_item_info">{transacao.pan || "-"}</p>
                      </div>
                      <div>
                        <p className="menu_item_label menu_margin_b-8=2">NSU</p>
                        <p className="menu_item_info">{transacao.atk || "-"}</p>
                      </div>
                    </div>
                  </div>

                  
                </MenuItem>

                <MenuItem>
                  <p
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                    className="menu_item_title menu_margin_b-8"
                  >
                    Faturas Pagas{" "}
                    <span
                      style={{
                        color: "#FFFFFF",
                        marginLeft: 8,
                        fontSize: 13,
                      }}
                      className="menu_circle"
                    >
                      {transacao.pagamento?.faturas.length || 0}
                    </span>
                  </p>
                  <table>
                    <thead>
                      <tr className="">
                        <th className="menu_item_label menu_padding_b-16">
                          Fatura
                        </th>
                        <th className="menu_item_label menu_padding_b-16">
                          Vencimento
                        </th>
                        <th className="menu_item_label float_right menu_padding_b-16">
                          Valor
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {transacao.pagamento?.faturas &&
                        transacao.pagamento?.faturas.map((fat) => {
                          return (
                            <tr className="" key={fat.id}>
                              <td className="menu_item_info_bold menu_padding_b-16">
                                {fat.ref}
                                {parseInt(fat.fd) > 0 ? " - " + fat.fd : ""}
                              </td>
                              <td className="menu_item_info_regular menu_padding_b-16">
                                {fat.vencimento}
                              </td>
                              <td className="menu_item_info_bold float_right menu_padding_b-16">
                                {renderMoney(fat.total)}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>

                  <OverlayTrigger
                    key={"1"}
                    placement="left"
                    //className='warning_fixed'
                    overlay={
                      <Tooltip id="menu_tool_tip">
                        <span style={{ textTransform: "capitalize" }}>
                          {FaturaVinculadaTooltipText()}
                          {VinculadasValorRestante() !== 0 && (
                            <span style={{ fontWeight: "bold" }}>
                              {renderMoney(Math.abs(VinculadasValorRestante()))}
                            </span>
                          )}
                        </span>
                      </Tooltip>
                    }
                  >
                    <div className="menu_top_fixed_tr">
                      <img alt="!" src={HighPriory} />
                    </div>
                  </OverlayTrigger>
                </MenuItem>
              </BodyMenu>*/}
            </ModalContainer>
          </ModalMainContainer>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export function LinkModalFilled(props: ModalProps) {
  const { modalVisible, setModalVisible, getTransacoes, selectedLink } = props;

  const [showScroll, setShowScroll] = useState(false);

  const [faturaInput, setFaturaInput] = useState("");
  const [faturaSearch, setFaturaSearch] = useState("");

  const [selectedInvoices, setSelectectedInvoices] = useState<number[]>([]);

  const [clienteVinculado, setClienteVinculado] = useState(true);
  const [clienteCheck, setClientCheck] = useState(false);
  const [faturaVinculada, setFaturaVinculada] = useState(false);

  const [clienteInput, setClientInput] = useState("");
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [invoicesMandatory, setInvoicesMandatory] = useState<Invoice[]>();

  const [uc, setUc] = useState("-");
  const [doc, setDoc] = useState("");
  const [cliente, setCliente] = useState("");

  //const [selectedInvoices, setSelectectedInvoices] = useState<number[]>([]);
  const [loadingInvoices, setLoadInvoices] = useState(false);

  const [faturasVinculadas, setFaturasVinculadas] = useState<LinkFatura[]>([]);

  const [addFaturas, setAddFaturas] = useState(false);
  const [osCorte, setOsCorte] = useState(false);

  useEffect(() => {
    if (invoices) {
      const f = invoices.find((i) => i.OS_CORTE === "S");
      if (f) {
        setOsCorte(true);
      }
    }
    const mandInv = invoices.filter((ti: Invoice) => checkIfMandatory(ti));

    setInvoicesMandatory(mandInv);
  }, [invoices]);

  const statuses = [
    "Processando",
    "Em andamento",
    "Cancelado",
    "Falha",
    "Pendente",
    "Processado",
    "",
    "Conflito",
    "Chargeback",
  ];

  /*function removerFaturaVinculada(f_id: number) {
		const faturasVinc = [...faturasVinculadas];
		const indexVinc = faturasVinc.findIndex((fv) => fv.FATURA_ID === f_id);
		if (indexVinc !== -1) {
			faturasVinc.splice(indexVinc, 1);
		}

		// setInvoiceList(f_id);
		setFaturasVinculadas([...faturasVinc]);
	}*/

  /*function setarFaturaVinculada() {
		const filter = invoices.filter((inv) =>
			selectedInvoices.includes(inv.FATURA_ID)
		);
		if (filter && filter.length > 0) {
			setFaturasVinculadas([...filter, ...faturasVinculadas]);
			setSelectectedInvoices([]);
		} else {
			setFaturasVinculadas([]);
		}
	} */

  /*function getStatusColor() {
    const data = [
      { label: "", color: "", value: -1 },
      { label: "Processando", color: "#1588D1", value: 0 },
      { label: "Em andamento", color: "#1588D1", value: 1 },
      { label: "Cancelado", color: "#757575", value: 2 },
      { label: "Falha", color: "#E53935", value: 3 },
      { label: "Pendente", color: "#7CB342", value: 4 },
      { label: "Completo", color: "#7CB342", value: 5 },
      { label: "Em conflito", color: "#FFBB33", value: 7 },
      { label: "CHARGEBACK", color: "#5E35B1", value: 8 },
      { label: "Rejeitado", color: "#757575", value: 9 },
      { label: "Restrito", color: "#757575", value: 11 },
      { label: "Registrado", color: "#7CB342", value: 12 },
    ];

    const f = data.find((d) => d.value === link?.status);
    if (f) {
      return f.color;
    }
    return "#676767";
  }*/

  const tipos = ["", "Débito", "Crédito"];

  function renderMoney(value: any) {
    value = parseFloat(value);
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      style: "currency",
      currency: "BRL",
    });
  }

  function handleScroll() {
    if (showScroll === false) {
      setShowScroll(true);

      setTimeout(() => {
        setShowScroll(false);
      }, 2000);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(modalVisible);
    if (!modalVisible) {
      setClienteVinculado(false);
      setFaturaVinculada(false);

      setClientCheck(false);
      setFaturaVinculada(false);
      setClientInput("");
      setFaturaInput("");
      setInvoices([]);
      setUc("-");
      setDoc("");
      setCliente("");
      setFaturaSearch("");
      setInvoices([]);
      setSelectectedInvoices([]);
      setFaturasVinculadas([]);
    } else {
      setClienteVinculado(false);
      setFaturaVinculada(false);
    }
  }, [modalVisible]);

  function formatDoc() {
    let value = doc;
    value = value.replace(/\D/g, "");
    if (value.length <= 11) {
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    } else {
      value = value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        "$1.$2.$3/$4-$5"
      );
    }
    return value;
  }
  /*
	function setInvoiceList(f_id: number) {
		const si = [...selectedInvoices];

		const index = si.findIndex((si) => si === f_id);

		if (index !== -1) {
			console.log(f_id);

			si.splice(index, 1);
		} else {
			si.push(f_id);
		}

		setSelectectedInvoices([...si]);
	}
	*/

  //GET /admin/ws/ref?doc=43861172291
  //GET /admin/ws/ref/15865/invoices

  /*
	function VinculadasValorRestanteStyled() {
		const res = VinculadasValorRestante();
		if (res > 0) {
			return `+ ${renderMoney(res.toString())}`;
		} else if (res === 0) {
			return `${renderMoney(res.toString())}`;
		} else {
			return `- ${renderMoney(Math.abs(res).toString())}`;
		}
	}
*/

  function setInvoiceList(f_id: number) {
    const si = [...selectedInvoices];

    const index = si.findIndex((si) => si === f_id);

    if (index !== -1) {
      console.log(f_id);

      si.splice(index, 1);
    } else {
      si.push(f_id);
    }

    setSelectectedInvoices([...si]);
  }

  // checa mandatorio
  function checkIfMandatory(inv: Invoice): boolean {
    if (
      inv.FORMA_PAGAMENTO === "O" &&
      getSituation(inv) !== 4 &&
      getSituation(inv) !== 5 &&
      inv.FLAG_CLIENTE_ATUAL === "1" &&
      !getProc(inv) &&
      ["ABER", "REAV", "TRAN"].includes(inv.SIT_FATURA_EDT)
    ) {
      return true;
    }

    return false;
  }

  function checkIdList(invoiceIdparse: number | null): boolean {
    if (invoiceIdparse) {
      const resp = selectedInvoices?.filter((invoice) => {
        return invoice === invoiceIdparse;
      });
      if (resp)
        if (resp?.length > 0) {
          return true;
        }
    }
    return false;
  }

  // Seta os juros, multas e correções da fatura selcionada

  function searchUcDoc(s: string) {
    getInvoices(s);

    /*if (s.length >= 11) {
			getDoc(s);
		} else {
		}*/
  }

  async function getDoc(doc: string) {
    try {
      const response = await api.get(`/admin/ws/ref?doc=${doc}`);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  async function getInvoices(uc: string) {
    setLoadInvoices(true);
    try {
      const response = await api.get(`/admin/ws/ref/${uc}/invoices?limit=60`);
      // console.log(response.data);
      if (response.data && response.data.length > 0) {
        setUc(uc);
        if (response.data && response.data[0]) {
          setDoc(
            response.data[0].NUMERO_DOCTO_1
              ? response.data[0].NUMERO_DOCTO_1
              : ""
          );
          setCliente(
            response.data[0].NOME_CLIENTE ? response.data[0].NOME_CLIENTE : ""
          );
          setFaturasVinculadas([]);
        }
        setInvoices(response.data.reverse());

        setClienteVinculado(true);
        setClientCheck(true);
      } else {
        setInvoices([]);
      }
      setLoadInvoices(false);
    } catch (error) {
      console.log(error);
      setLoadInvoices(false);
    }
  }

  const [createdLink, setCreatedLink] = useState<LinkPagamento | undefined>();
  const [loadingCreateLink, setLoadingCreateLink] = useState(false);

  async function sendEmailSmsWhats(type: string, content: any) {
    try {
      const uname = process.env.REACT_APP_UNAME || "";
      const pass = process.env.REACT_APP_PASS || "";
      const url =
        type === "mail"
          ? "https://bot-rpa.metasix.solutions/api/v1/mail-sms-whats"
          : type === "whatsapp"
          ? " https://api-chatbot.amazonasenergia.com/api/stone/whatsapp"
          : "https://api-chatbot.amazonasenergia.com/api/stone/sms";
      const postData = type === "mail" ? { type, content } : content;
      
      const token2 = `${process.env.REACT_APP_SMSWHATS_TOKEN}`
      const response = await axios.post(
        url,
        postData,
        type === "mail"
          ? {
              auth: {
                username: uname,
                password: pass,
              },
            }
          : {
            
              headers: {
                Authorization: `Bearer ${token2}`,
              },
            }
      );

      if (response.data) {
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
    return false;
  }

  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [modalInfoType, setModalInfoType] = useState<string | undefined>();

  // Seta a situação das Faturas
  function getSituation(situation: Invoice): number {
    /*if (
      situation.NUM_LOTE_ARREC !== null &&
      ['TRAN', 'ABER', 'REAV'].includes(situation.SIT_FATURA_EDT)
    ) {
      return 5
    }*/
    if (
      situation.CAUC_061_DT_FIM_VIGENCIA !== null &&
      ["TRAN", "ABER", "REAV"].includes(situation.SIT_FATURA_EDT)
    ) {
      if (situation.CAUC_061_DT_FIM_VIGENCIA.length < 10) {
        const dateConf = `${situation.CAUC_061_DT_FIM_VIGENCIA.substr(
          0,
          6
        )}20${situation.CAUC_061_DT_FIM_VIGENCIA.substr(6, 8)}`;
        if (checkDueDate(dateConf)) {
          return 6;
        }
      } else if (situation.CAUC_061_DT_FIM_VIGENCIA.length === 10) {
        if (checkDueDate(situation.CAUC_061_DT_FIM_VIGENCIA)) {
          return 6;
        }
      }
    }

    const situationsInvoices = [
      { id: 1, name: "TRAN", type: 2 },
      { id: 2, name: "ABER", type: 2 },
      { id: 3, name: "REAV", type: 2 },
      { id: 4, name: "PAGR", type: 4 },
      { id: 5, name: "PAGA", type: 4 },
      { id: 6, name: "PROC", type: 5 },
      { id: 7, name: "CONF", type: 5 },
    ];
    const respoSituation = situationsInvoices.filter(
      (sit) => sit.name === situation.SIT_FATURA_EDT
    )[0].type;
    if (respoSituation) {
      return respoSituation;
    }
    return 0;
  }

  function checkDueDate(dataInvoice: string): boolean {
    const [day, month, year] = dataInvoice.split("/");
    const dateInvoice = new Date(
      parseInt(year, DECIMAL_NUMBER),
      parseInt(month, DECIMAL_NUMBER) - 1,
      parseInt(day, DECIMAL_NUMBER)
    );
    const newDate = new Date();
    dateInvoice.setHours(23, 59, 59, 999);

    return isAfter(dateInvoice, newDate);
  }
  // checka se invoice esta em analise
  function getAnalise(invoiceItem: Invoice): boolean {
    return invoiceItem.FORMA_PAGAMENTO === "I";
  }

  // checka se invoice esta processando
  function getProc(invoiceItem: Invoice): boolean {
    return (
      invoiceItem.SIT_FATURA_EDT === "PROC" ||
      invoiceItem.SIT_FATURA_EDT === "CONF"
    );
  }

  useEffect(() => {
    if (selectedLink) {
      setCliente(
        selectedLink.pagamento && selectedLink.pagamento.cliente
          ? selectedLink.pagamento.cliente
          : "-"
      );
      setDoc(
        selectedLink.pagamento && selectedLink.pagamento.doc
          ? selectedLink.pagamento.doc
          : ""
      );
      setUc(
        selectedLink.pagamento && selectedLink.pagamento.uc
          ? selectedLink.pagamento.uc
          : "SEM UC"
      );

      setFaturasVinculadas(
        selectedLink.pagamento &&
          selectedLink.pagamento &&
          selectedLink.pagamento.faturas
          ? selectedLink.pagamento.faturas
          : []
      );
      setCreatedLink(selectedLink);
    }
  }, [selectedLink]);

  return (
    <Modal
      fullscreen
      dialogClassName="hide-this-modal"
      centered={false}
      animation={false}
      show={modalVisible}
      onHide={() => {
        setModalVisible(false);
      }}
    >
      {openModalInfo && createdLink && (
        <ModalInfo
          modalVisible={openModalInfo}
          setModalVisible={setOpenModalInfo}
          // type={modalInfoType}
          sendEmailSmsWhats={sendEmailSmsWhats}
          createdLink={createdLink}
        />
      )}
      <Modal.Body>
        <div
          onClick={(e) => {
            e.preventDefault();
            setModalVisible(false);
          }}
          style={{
            position: "fixed",
            height: "100vh",
            width: "100vw",
            //background: 'rgba(0,0,0,0.1)',
            top: 0,
            left: 0,
            display: "flex",
            //flexDirection:'row',
            justifyContent: "flex-end",
          }}
        >
          <ModalMainContainer
            visible={showModal}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <ModalHeader>
              <HeaderTitle>{"Link de Pagamento"}</HeaderTitle>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <HeaderButton
                  onClick={(e) => {
                    e.preventDefault();
                    //EditEmpresa();
                    setModalVisible(false);
                  }}
                  style={{ background: "transparent", color: "#676767" }}
                >
                  Cancelar
                </HeaderButton>
              </div>
            </ModalHeader>
            <ModalContainer showScroll={showScroll}>
              <BodyMenu>
                <MenuItem showChecked={clienteCheck}>
                  <p className="menu_item_title menu_margin_b-8">Cliente</p>

                  <div className="menu_margin_b-16">
                    <p className="menu_item_label menu_margin_b-2">nome</p>
                    <p className="menu_item_info">{cliente}</p>
                  </div>

                  <div
                    className={clienteCheck ? "menu_margin_b-16" : ""}
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginRight: 25 }}>
                      <p className="menu_item_label menu_margin_b-2">UC</p>
                      <p className="menu_item_info">{uc}</p>
                    </div>
                    <div>
                      <p className="menu_item_label menu_margin_b-8=2">
                        documento
                      </p>
                      <p className="menu_item_info">{formatDoc()}</p>
                    </div>
                  </div>

                  {/* clienteCheck && (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          searchUcDoc(clienteInput);
                        }}
                        className="menu_input_container"
                      >
                        {clienteInput.length === 0 && (
                          <img
                            style={{ width: 12, height: 12 }}
                            alt="search"
                            src={SearchIcon}
                          />
                        )}
                        <input
                          type="text"
                          value={clienteInput}
                          onChange={(e) => {
                            setClientInput(e.target.value);
                          }}
                          placeholder="Buscar por UC ou documento"
                        />
                        {clienteInput.length > 0 && (
                          <button
                            type="submit"
                            onClick={(e) => {
                              e.preventDefault();
                              searchUcDoc(clienteInput);
                            }}
                            className="menu_search_button"
                          >
                            Buscar
                          </button>
                        )}
                      </form>
                    )*/}

                  <OverlayTrigger
                    key={"1"}
                    placement="left"
                    //className='warning_fixed'
                    overlay={
                      <Tooltip id="menu_tool_tip">
                        <span style={{ textTransform: "capitalize" }}>
                          Cliente vinculado
                        </span>
                      </Tooltip>
                    }
                  >
                    <div className="menu_top_fixed_tr_checked">
                      <img alt="v" src={VerifiedWhite} />
                    </div>
                  </OverlayTrigger>
                </MenuItem>
                {
                  <MenuItem
                    showWarning={!(faturasVinculadas.length > 0)}
                    showChecked={faturasVinculadas.length > 0}
                  >
                    <p className="menu_item_title menu_margin_b-8">
                      {faturasVinculadas.length > 0 && !addFaturas
                        ? "Faturas selecionadas"
                        : "Selecionar faturas"}
                    </p>

                    {faturasVinculadas.length > 0 && !addFaturas && (
                      <table style={{ marginTop: "12px" }}>
                        <thead>
                          <tr className="">
                            <th className="menu_item_label menu_padding_b-16">
                              Fatura
                            </th>
                            <th className="menu_item_label menu_padding_b-16">
                              Vencimento
                            </th>
                            <th className="menu_item_label float_right menu_padding_b-16">
                              Valor
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {faturasVinculadas.map((inv) => {
                            return (
                              <tr key={`${inv.id}`} className="">
                                <td className="menu_item_info_bold menu_padding_b-16 h-32px">
                                  {inv.ref}{" "}
                                  {parseInt(inv.fd ? inv.fd : "0") > 0
                                    ? " - " + inv.fd
                                    : ""}
                                </td>
                                <td className="menu_item_info_regular menu_padding_b-16 h-32px">
                                  {inv.vencimento}
                                </td>
                                <td
                                  style={{
                                    background: "transparent",
                                    boxShadow: "none",
                                  }}
                                  className="menu_item_info_bold menu_item_info_value_container float_right menu_margin_b-16"
                                >
                                  <div className="text_container">
                                    {renderMoney(inv.total)}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}

                    <OverlayTrigger
                      key={"1"}
                      placement="left"
                      //className='warning_fixed'
                      overlay={
                        <Tooltip id="menu_tool_tip">
                          <span style={{ textTransform: "capitalize" }}>
                            Cliente encontrado
                          </span>
                        </Tooltip>
                      }
                    >
                      <div className="menu_top_fixed_tr_checked">
                        <img alt="v" src={VerifiedWhite} />
                      </div>
                    </OverlayTrigger>
                  </MenuItem>
                }

                {createdLink && (
                  <MenuItem>
                    <p className="menu_item_title menu_margin_b-8">
                      Enviar Link de Pagamento
                    </p>
                    <div
                      style={{
                        marginTop: "16px", // display: "none"
                      }}
                      className="menu_input_container"
                    >
                      <img
                        style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "14px",
                        }}
                        alt="link"
                        src={LinkBlack}
                      />
                      <ElipisisText
                        style={{
                          maxWidth: "395px",
                        }}
                      >{`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${createdLink.id}?secret=${createdLink.secret}`}</ElipisisText>
                      <CopyToClipboard
                        text={`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${createdLink.id}?secret=${createdLink.secret}`}
                      >
                        <CopyButton
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setOpenModalInfo(true);
                          }}
                          style={{ width: "150px", marginLeft: "24px" }}
                        >
                          <img alt="copy" src={send_filled_white} />
                          <span>Enviar link</span>
                        </CopyButton>
                      </CopyToClipboard>
                    </div>
                    <div
                      style={{
                        // display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gridGap: "16px",
                        marginTop: "16px",
                        display: "none",
                      }}
                    >
                      <CopyButton
                        onClick={(e) => {
                          setOpenModalInfo(true);
                          setModalInfoType("whatsapp");
                        }}
                        style={{ width: "100%" }}
                      >
                        <img alt="Whats" src={WhatsWhite} />
                        <span>Enviar por WhatsApp</span>
                      </CopyButton>
                      <CopyButton
                        onClick={(e) => {
                          setOpenModalInfo(true);
                          setModalInfoType("sms");
                        }}
                        style={{ width: "100%" }}
                      >
                        <img alt="sms" src={SmsWhite} />
                        <span>Enviar por SMS</span>
                      </CopyButton>
                      <CopyButton
                        onClick={(e) => {
                          setOpenModalInfo(true);
                          setModalInfoType("mail");
                        }}
                        style={{ width: "100%" }}
                      >
                        <img alt="e-mail" src={EmailWhite} />
                        <span>Enviar por E-mail</span>
                      </CopyButton>
                    </div>
                  </MenuItem>
                )}

                {/* <MenuItem>
                  <div
                    className="menu_margin_b-20"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p className="menu_item_title">Pagamento </p>
                    <div
                      style={{
                        background: getStatusColor(),
                      }}
                      className="menu_item_status"
                    >
                      {statuses[transacao?.status]}
                    </div>
                  </div>
                  <div
                    className="menu_margin_b-16"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p className="menu_item_label">total pago</p>
                    <p className="menu_item_heavy">
                      {renderMoney(transacao?.valor)}
                    </p>
                  </div>

                  <div
                    className="menu_margin_b-16"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p className="menu_item_label">Criado em</p>
                    <p className="menu_item_info">
                      {momentTZ
                        .tz(transacao?.cadastro, "America/Sao_Paulo")
                        .format("DD/MM/YYYY HH:mm:ss")}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p className="menu_item_label">Processado em</p>
                    <p className="menu_item_info">
                      {transacao?.processado
                        ? momentTZ
                            .tz(transacao?.processado, "America/Sao_Paulo")
                            .format("DD/MM/YYYY HH:mm:ss")
                        : "-"}
                    </p>
                  </div>
                </MenuItem>*/}

                {/* <MenuItem>
                  <p className="menu_item_title menu_margin_b-8">
                    Ponto de Venda
                  </p>

                  <div
                    className="menu_margin_b-16"
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <p className="menu_item_label menu_margin_b-2">
                        nome da loja
                      </p>
                      <p className="menu_item_info">
                        {transacao?.pontoVenda &&
                        transacao?.pontoVenda.unidade &&
                        transacao?.pontoVenda.unidade.nome
                          ? transacao.pontoVenda.unidade.nome
                          : "-"}
                      </p>
                    </div>
                    <div>
                      <p className="menu_item_label menu_margin_b-2">
                        Identificador
                      </p>
                      <p className="menu_item_info">
                        {transacao?.pontoVenda
                          ? transacao?.pontoVenda.apelido.toUpperCase()
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="menu_item_label menu_margin_b-2">Cidade</p>
                    <p className="menu_item_info">
                      {transacao?.pontoVenda &&
                      transacao?.pontoVenda.unidade &&
                      transacao?.pontoVenda.unidade.cidade
                        ? transacao?.pontoVenda.unidade.cidade
                        : "-"}
                    </p>
                  </div>

                  <OverlayTrigger
                    key={"1"}
                    placement="left"
                    overlay={
                      <Tooltip id="menu_tool_tip">
                        <span style={{ textTransform: "capitalize" }}>
                          item local
                        </span>
                      </Tooltip>
                    }
                  >
                    <div className="menu_bottom_fixed_br">
                      <img alt="store" src={StoreWhite} />
                    </div>
                  </OverlayTrigger>
                </MenuItem>*/}

                {/* <MenuItem style={{ display: "none" }}>
                  <p className="menu_item_title menu_margin_b-8">Ajuri</p>

                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginRight: 25 }}>
                      <p className="menu_item_label menu_margin_b-2">
                        Identificador
                      </p>
                      <p className="menu_item_info">
                        {`transacao?.identificador || '-'`}
                      </p>
                    </div>
                    <div>
                      <p className="menu_item_label menu_margin_b-8=2">cupom</p>
                      <p className="menu_item_info">
                        {`transacao?.cupom || '-'`}
                      </p>
                    </div>
                  </div>
                </MenuItem>*/}

                {<div style={{ background: "transparent", padding: 10 }} />}
              </BodyMenu>
              {/*<BodyMenu style={{ marginLeft: 16 }}>
                <MenuItem>
                  <p className="menu_item_title menu_margin_b-8">
                    Detalhes da transação
                  </p>

                  <div className={""}>
                    <div
                      className="menu_margin_b-16"
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <p className="menu_item_label menu_margin_b-2">Tipo</p>
                        <p className="menu_item_info">
                          {tipos[parseInt(transacao.tipo)]} (
                          {transacao.parcelas ? transacao.parcelas : "1"}x)
                        </p>
                      </div>
                      <div>
                        <p className="menu_item_label menu_margin_b-8=2">
                          Valor
                        </p>
                        <p className="menu_item_info">
                          {renderMoney(transacao.valor)}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <p className="menu_item_label menu_margin_b-2">Pan</p>
                        <p className="menu_item_info">{transacao.pan || "-"}</p>
                      </div>
                      <div>
                        <p className="menu_item_label menu_margin_b-8=2">NSU</p>
                        <p className="menu_item_info">{transacao.atk || "-"}</p>
                      </div>
                    </div>
                  </div>

                  
                </MenuItem>

                <MenuItem>
                  <p
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                    className="menu_item_title menu_margin_b-8"
                  >
                    Faturas Pagas{" "}
                    <span
                      style={{
                        color: "#FFFFFF",
                        marginLeft: 8,
                        fontSize: 13,
                      }}
                      className="menu_circle"
                    >
                      {transacao.pagamento?.faturas.length || 0}
                    </span>
                  </p>
                  <table>
                    <thead>
                      <tr className="">
                        <th className="menu_item_label menu_padding_b-16">
                          Fatura
                        </th>
                        <th className="menu_item_label menu_padding_b-16">
                          Vencimento
                        </th>
                        <th className="menu_item_label float_right menu_padding_b-16">
                          Valor
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {transacao.pagamento?.faturas &&
                        transacao.pagamento?.faturas.map((fat) => {
                          return (
                            <tr className="" key={fat.id}>
                              <td className="menu_item_info_bold menu_padding_b-16">
                                {fat.ref}
                                {parseInt(fat.fd) > 0 ? " - " + fat.fd : ""}
                              </td>
                              <td className="menu_item_info_regular menu_padding_b-16">
                                {fat.vencimento}
                              </td>
                              <td className="menu_item_info_bold float_right menu_padding_b-16">
                                {renderMoney(fat.total)}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>

                  <OverlayTrigger
                    key={"1"}
                    placement="left"
                    //className='warning_fixed'
                    overlay={
                      <Tooltip id="menu_tool_tip">
                        <span style={{ textTransform: "capitalize" }}>
                          {FaturaVinculadaTooltipText()}
                          {VinculadasValorRestante() !== 0 && (
                            <span style={{ fontWeight: "bold" }}>
                              {renderMoney(Math.abs(VinculadasValorRestante()))}
                            </span>
                          )}
                        </span>
                      </Tooltip>
                    }
                  >
                    <div className="menu_top_fixed_tr">
                      <img alt="!" src={HighPriory} />
                    </div>
                  </OverlayTrigger>
                </MenuItem>
              </BodyMenu>*/}
            </ModalContainer>
          </ModalMainContainer>
        </div>
      </Modal.Body>
    </Modal>
  );
}

interface MainContainerProps {
  visible?: boolean;
}

const ModalMainContainer = styled.div<MainContainerProps>`
  //padding-top: 25px;
  //padding-left: 50px;
  //padding-right: 20000px;
  //padding-bottom: 25px;
  //min-height: 100vh;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: -12px 12px 16px #00000029;
  width: 100vw;
  max-width: 730px;
  //margin-left: 50vw;
  height: calc(100vh);
  //padding-bottom: 30px;
  //flex: 1;
  transition: all 0.4s;

  opacity: ${(props) => (props.visible ? 1 : 0)};
`;

const ModalHeader = styled.div`
  background: #f6f6f6 0% 0% no-repeat padding-box;
  //box-shadow: 0px 16px 16px #00000029;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 21px;
  padding-bottom: 21px;

  padding-left: 30px;
  padding-right: 30px;
  height: 80px;
`;

const HeaderTitle = styled.h1`
  font: normal normal 500 24px/32px Roboto;
  letter-spacing: 0px;
  color: #222222;
`;

const HeaderButton = styled.button`
  border-radius: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  padding-left: 16px;
  padding-right: 16px;

  text-align: center;
  font: normal normal 500 16px/21px Roboto;
  letter-spacing: 0px;
  border: 0;
`;

interface ModalContainerProps {
  showScroll?: boolean;
}

const ModalContainer = styled.div<ModalContainerProps>`
  background: #ffffff 0% 0% no-repeat padding-box;
  //	box-shadow: -16px 0px 16px #00000029;
  opacity: 1;
  display: flex;
  flex-direction: row;
  //flex: 1;
  height: calc(100vh - 80px - 20px);
  padding: 30px;
  padding-top: 0;
  margin-top: 20px;
  //margin-bottom: 20px;
  overflow-y: scroll;
  //border-bottom: solid 20px #0F0;

  //padding-bottom: 50000px;

  ::-webkit-scrollbar {
    background: transparent;

    // display:none;

    width: 12px;
  }

  &::-webkit-scrollbar-track {
    /*  margin-top:0;
      border-bottom-right-radius: 16px;
      background-image: url("https://i.stack.imgur.com/Pwbuz.png");
    background-repeat: repeat-y;
    background-size: contain;
      */
    // margin-top: 54px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) =>
      props.showScroll ? "rgba(103, 103, 103, 0.5)" : "transparent"};
    border-radius: 20px;
    border: 2.5px solid rgba(0, 0, 0, 0);
    border-right: 5px solid rgba(0, 0, 0, 0);

    background-clip: padding-box;
    max-height: 5px;
    transition: all 1s;
  }
`;

const BodyMenu = styled.div`
  /*padding-left: 30px;
	padding-right: 30px;
	max-height: calc(100vh - 80px);*/
  display: flex;
  //justify-content: space-between;
  flex: 1;
  flex-direction: column;
  //border-bottom:solid 20px #F0F;

  /*padding-top: 30px;
	padding-bottom: 30px;*/
  //border-bottom: 100px solid #000;

  //border-right: 1px solid #f0f0f0;
`;

interface MenuItemProps {
  showWarning?: boolean;
  showChecked?: boolean;
}

const MenuItem = styled.div<MenuItemProps>`
  background: #f6f6f6 0% 0% no-repeat padding-box;
  border-radius: 24px;
  padding: 20px;
  margin-bottom: 15px;
  position: relative;

  input {
    outline: none;
  }

  .menu_input_container {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029;
    border-radius: 19px;
    height: 38px;
    display: flex;
    flex-direction: row;
    //padding: 12px;
    padding-right: 0;
    align-items: center;
    padding-left: 12px;

    img {
      width: 20px;
      height: 20px;
    }

    input {
      flex: 1;
      //::after//margin-top: -12px;
      //margin-bottom: -12px;
      margin: 0;
      background: transparent;
      height: 38px;
      border: 0;
    }

    .menu_search_button {
      background: #28a745 0% 0% no-repeat padding-box;
      border-radius: 19px;
      height: 38px;
      text-align: center;
      font: normal normal 500 13px/18px Roboto;
      letter-spacing: 0px;
      color: #ffffff;
      //margin-top: -12px;
      //margin-bottom: -12px;
      padding-left: 16px;
      padding-right: 16px;
      display: flex;
      align-items: center;
      border: 0;
    }
  }

  .green_round_button {
    background: #28a745 0% 0% no-repeat padding-box;
    border-radius: 19px;
    height: 38px;
    text-align: center;
    font: normal normal 500 13px/18px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
    //margin-top: -12px;
    //margin-bottom: -12px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    width: 100%;
  }

  .float_right {
    float: right;
  }

  .table_row {
  }

  table {
    width: 100%;
    border-spacing: 16px;
  }

  .menu_gray_line {
    border-bottom: 1px solid #998f8f;
  }

  .menu_margin_b-8 {
    margin-bottom: 8px;
  }
  .menu_padding_b-8 {
    padding-bottom: 8px;
  }

  .menu_margin_b-24 {
    margin-bottom: 24px;
  }
  .menu_padding_b-24 {
    padding-bottom: 24px;
  }

  .menu_margin_b-16 {
    margin-bottom: 16px;
  }

  .menu_margin_b-32 {
    margin-bottom: 32px;
  }

  .menu_padding_b-16 {
    padding-bottom: 16px;
  }
  .menu_margin_b-2 {
    margin-bottom: 2px;
  }

  .menu_margin_b-20 {
    margin-bottom: 20px;
  }

  .menu_circle {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #28a745 0% 0% no-repeat padding-box;
    border-radius: 12px;
    width: 24px;
    height: 24px;
  }

  p {
    margin: 0;
  }

  .menu_item_title {
    text-align: left;
    font: normal normal bold 16px/21px Roboto;
    letter-spacing: 0px;
    color: #222222;
  }
  .menu_item_label {
    text-align: left;
    font: normal normal normal 11px/15px Roboto;
    letter-spacing: 0px;
    color: #676767;
    text-transform: uppercase;
  }

  .menu_item_info {
    text-align: left;
    font: normal normal 500 15px/20px Roboto;
    letter-spacing: 0px;
    color: #222222;
  }

  .menu_item_info_bold {
    text-align: left;
    font: normal normal 700 13px/18px Roboto;
    letter-spacing: 0px;
    color: #222222;
  }

  .h-32px {
    height: 32px;
  }

  .menu_item_info_value_container {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029;
    border-radius: 16px;
    padding: 4px;
    height: 32px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    .text_container {
      flex: 1;
      text-align: right;
      padding-right: 8px;
    }

    .delete_button {
      width: 24px;
      height: 24px;
      color: #ffffff;
      background: #dc3545;
      border: 0;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .menu_item_info_regular {
    text-align: left;
    font: normal normal 400 13px/18px Roboto;
    letter-spacing: 0px;
    color: #222222;
  }

  .menu_item_status {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    //background: #676767 0% 0% no-repeat padding-box;
    border-radius: 10px;
    font: normal normal 500 10px Roboto;
    letter-spacing: 0.5px;
    color: #ffffff;
    text-transform: uppercase;
    padding-left: 12px;
    padding-right: 12px;
  }

  .menu_item_heavy {
    text-align: right;
    font: normal normal bold 18px/24px Roboto;
    letter-spacing: 0px;
    color: #222222;
  }

  .menu_bottom_fixed_br {
    position: absolute;
    background: #28a745 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 6px 6px #00000029;
    border-radius: 24px 0px;
    bottom: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    display: flex;
  }

  .menu_top_fixed_tr_checked {
    position: absolute;
    background: #28a745 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 6px 6px #00000029;
    border-radius: 0px 24px;
    top: 0;
    right: 0;
    display: ${(props) => (props.showChecked ? "flex" : "none")};

    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
  }

  .menu_top_fixed_tr {
    position: absolute;
    background: #fec12d 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 6px 6px #00000029;
    border-radius: 0px 24px;
    top: 0;
    right: 0;
    display: ${(props) => (props.showWarning ? "flex" : "none")};

    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
  }

  .menu_paid_total {
    .row_container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font: normal normal 500 13px/18px Roboto;
      letter-spacing: 0px;
      color: #222222;
      p {
        margin: 0;
      }
    }
  }
`;

const FaturaDropdown = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 16px #00000029;
  border: 1px solid #ebebeb;
  border-radius: 19px;
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 21px;
  padding-top: 12px;
  position: absolute;
  transform: translate(-20px, 5px);
  width: 100%;

  .tableContainer {
    max-height: 150px;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      width: 0px;
    }
  }

  .botaoVincular {
    border: 0;
    background: #28a745 0% 0% no-repeat padding-box;
    border-radius: 19px;
    height: 38px;
    font: normal normal 500 13px/18px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
    width: 100%;
    margin-top: 24px;
  }

  table {
    thead {
      tr {
        th {
          font: normal normal normal 9px/11px Roboto;
          letter-spacing: 0px;
          color: #676767;
          text-transform: uppercase;
          position: -webkit-sticky; /* Safari */
          position: sticky;
          top: 0;
          background: #ffffff;
        }
      }
    }
    tbody {
      tr {
        td {
          font: normal normal normal 13px/24px Roboto;
          letter-spacing: 0px;
          color: #212529;

          .select_button {
            background: #ffffff 0% 0% no-repeat padding-box;
            border: 1px solid #b7b7b7;
            border-radius: 3px;
            width: 14px;
            height: 14px;
            margin-right: 4px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 10px;
              height: 10px;
            }
          }
        }
      }
    }
  }
`;

const FaturaScroll = styled.div`
  background: transparent 0% 0% no-repeat padding-box;
  //box-shadow: 0px 8px 16px #00000029;
  //border: 1px solid #ebebeb;
  border-radius: 19px;
  //padding-right: 16px;
  //padding-left: 16px;
  // padding-bottom: 21px;
  padding-top: 12px;
  // position: absolute;
  // transform: translate(-20px, 5px);
  width: 100%;
  //max-height:100%;

  .tableContainer {
    //max-height: 100%;
    max-height: calc(
      100vh - 175px - 15px - 30px - 80px - 12px - 21px - 8px - 40px - 60px
    );
    overflow-y: scroll;
    ::-webkit-scrollbar {
      width: 0px;
    }
  }

  .botaoVincular {
    border: 0;
    background: #28a745 0% 0% no-repeat padding-box;
    border-radius: 19px;
    height: 38px;
    font: normal normal 500 13px/18px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
    width: 100%;
    margin-top: 24px;
  }

  table {
    thead {
      tr {
        th {
          font: normal normal normal 9px/11px Roboto;
          letter-spacing: 0px;
          color: #676767;
          text-transform: uppercase;
          position: -webkit-sticky; /* Safari */
          position: sticky;
          top: 0;
          background: #f6f6f6;
        }
      }
    }
    tbody {
      tr {
        border-bottom: 1px solid #f6f6f6;
        td {
          font: normal normal normal 13px/24px Roboto;
          letter-spacing: 0px;
          color: #212529;

          .select_button {
            background: #ffffff 0% 0% no-repeat padding-box;
            border: 1px solid #b7b7b7;
            border-radius: 3px;
            width: 14px;
            height: 14px;
            margin-right: 4px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 10px;
              height: 10px;
            }
          }
        }
      }
    }
  }
`;

const CopyButton = styled.button`
  outline: none;
  border: none;

  background: #1069d9 0% 0% no-repeat padding-box;
  border-radius: 19px;
  height: 38px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 148px;
  width: fit-content;

  text-align: center;
  font: normal normal 500 13px/18px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  img {
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
`;

const ElipisisText = styled.p`
  margin: 0;
  text-align: left;
  font: normal normal normal 13px/18px Roboto;
  letter-spacing: 0px;
  color: #222222;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  max-width: 391px;
`;
